// External Dependencies:
import 'babel-polyfill'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import configureStore from 'store/configure-store'

import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'
import PageTracker from 'components/page-tracker/page-tracker'

import objectFitImages from 'object-fit-images'
objectFitImages()

const store = configureStore()

// Internal Dependencies:
import HomeLayout from 'layouts/main/home-layout'
import TakeMeHomeLayout from 'layouts/main/take-me-home-layout'
import MainLayout from 'layouts/main/main-layout'
import FbCustomerChat from 'components/facebook/facebook-customer-chat'

ReactDOM.render(
	<Provider store={ store }>
		<BrowserRouter>
			<Switch>
				<Route path="/" render={ props => {
					const { location } = props
					let showBanner = ! location.pathname.includes( 'take-me-home' )

					return (
						<div>
							<FbCustomerChat { ...props } />

							{ showBanner &&
								<a href="/take-me-home" className="take-me-home-banner-b">
									<span className="-inner">
										<span className="-image">
											<img src={ `${safeSiteData.images_url}take-me-home/season-2/take-me-home-banner-top-2024.jpg` } alt="" />
										</span>
									</span>
								</a>
							}

							<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
								<Switch>
									<Route path="/" exact component={ PageTracker( HomeLayout ) } />
									<Route path="/take-me-home" exact component={ PageTracker( TakeMeHomeLayout ) } />

									<Route path="/:page" exact component={ PageTracker( MainLayout ) } />
									<Route path="/:parent/:page" exact component={ PageTracker( MainLayout ) } />
									<Route component={ PageTracker( MainLayout ) } />
								</Switch>
							</TransitionGroup>
						</div>
					)
				} } />
			</Switch>
		</BrowserRouter>
	</Provider>,

	document.getElementById( 'app' )
)



// WEBPACK FOOTER //
// ./app.jsx